export interface NavItem {
  to: string
  label: string
  icon: string
  requiredPermissions?: string[]
}

// Nur Module, die wirklich existieren (Phase 1-4). Automation/Discord folgen in
// späteren Phasen — keine toten Navigationspunkte.
export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: '◱' },
  { to: '/projects', label: 'Projekte', icon: '◫', requiredPermissions: ['projects.view'] },
  { to: '/tasks', label: 'Aufgaben', icon: '☑', requiredPermissions: ['tasks.view'] },
  { to: '/chat', label: 'Chat', icon: '💬', requiredPermissions: ['chat.use'] },
  { to: '/reminders', label: 'Reminder', icon: '⏰' },
  { to: '/users', label: 'Benutzer', icon: '◍', requiredPermissions: ['users.view'] },
  { to: '/roles', label: 'Rollen', icon: '◈', requiredPermissions: ['users.view'] },
  { to: '/servers', label: 'Server', icon: '📡', requiredPermissions: ['servers.view'] },
  { to: '/time-tracking', label: 'Zeiterfassung', icon: '⏱', requiredPermissions: ['projects.view'] },
  { to: '/audit', label: 'Audit-Log', icon: '≣', requiredPermissions: ['logs.view'] },
  { to: '/settings', label: 'Einstellungen', icon: '⚙', requiredPermissions: ['settings.manage'] },
]

export const MOBILE_NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Start', icon: '◱' },
  { to: '/tasks', label: 'Aufgaben', icon: '☑', requiredPermissions: ['tasks.view'] },
  { to: '/chat', label: 'Chat', icon: '💬', requiredPermissions: ['chat.use'] },
  { to: '/profile', label: 'Profil', icon: '●' },
]

// Alles aus NAV_ITEMS, was nicht schon direkt in der Bottom-Nav sitzt — erreichbar über
// den "Mehr"-Button (MoreMenuModal). Ohne dieses Menü wären Projekte, Reminder, Benutzer,
// Rollen, Audit-Log und Einstellungen auf Smartphone-Breite gar nicht erreichbar gewesen.
const MOBILE_NAV_PATHS = new Set(MOBILE_NAV_ITEMS.map((item) => item.to))
export const MOBILE_MORE_ITEMS: NavItem[] = NAV_ITEMS.filter((item) => !MOBILE_NAV_PATHS.has(item.to))
